import * as d3 from "d3";
import Animation from "../constants/animation";
import { TweenLite, Linear, Sine } from "gsap/all";
import { Engines_zmap } from "../constants/config";
import { p } from "gsap/RoundPropsPlugin";
const d3fetch = require("d3-fetch");
const appBarHeight = 30;

export default class Setup {
  constructor(mapEl = null, InteractiveMap = null) {
    this.mapEl = mapEl;
    this.InteractiveMap = InteractiveMap;
    this.init();
    this.svg = null;
    this.tip = null;
    this.lastActive = null;
    this.animation = null;
    this.zoom = null;
    this.isZoom = false;
    this.transformVal = d3.zoomIdentity.translate(0, 148).scale(1);
  }

  init = async () => {
    try {
      const xml = await d3fetch.xml(
        "./assets/GE_Aviation_Timeline_DEV_ASSET-02.svg"
      );
      // "xml" is the XML DOM tree
      this.startup(xml);
      // this.addZoom();
      this.addEventListeners();
      // Create Event Handlers for mouse
    } catch (error) {
      alert("error");
      console.log(error);
    }
  };

  startup = xml => {
    const htmlSVG = this.mapEl.current; // the svg-element in our HTML file
    // append the "maproot" group to the svg-element in our HTML file
    const nodes = [...xml.documentElement.children];
    this.maproot = d3.select(htmlSVG).append("g");
    nodes.forEach(node => this.maproot.node().appendChild(node));
    this.svg = d3.select(htmlSVG);
    this.InteractiveMap.toggle();
    // get the svg-element from the original SVG file
    const xmlSVG = d3.select(xml.getElementsByTagName("svg")[0]);
    // this.maproot.selectAll("#BACKGROUND > g > g rect").attr("width", 3000);

    this.svg
      .attr("viewBox", xmlSVG.attr("viewBox"))
      .attr("preserveAspectRatio", "xMinYMin meet");

    this.animation = new Animation(this.maproot);
    this.animation.start();
    document.getElementById("CLOUDS2").style.display = "inline";
    document.getElementById("timeline-container").style.background =
      "-webkit-linear-gradient(top, #3962ab 0%,#3962ab 30%,#60cde9 31%,#60cde9 100%)";
    // else this.animation.showEverything();

    // this.animation.showEverything();
  };

  hideline() {
    const display = this.maproot.select("#CONTRAILS_BLUE").style("display");
    if (display !== "none") {
      this.maproot.select("#CONTRAILS_BLUE").style("display", "none");
    } else {
      this.maproot.select("#CONTRAILS_BLUE").style("display", "inline");
    }
  }
  //
  replayAnimation() {
    this.animation.replay();
  }

  addZoom = () => {
    zoomed2 = zoomed2.bind(this);
    this.zoom = d3
      .zoom()
      .scaleExtent([1, 40])
      .translateExtent([
        [-100, -1000],
        [window.innerWidth * 4, window.innerHeight * 4]
      ])
      .on("zoom", zoomed2);

    function zoomed2() {
      // alert('too');
      if (this.InteractiveMap.fullScreen) {
        this.transformVal = d3.event.transform;
        this.maproot.attr("transform", d3.event.transform);
        const node = this.maproot.node();
        const ratio = window.innerWidth / node.getBBox().width;
        // console.log(node.getBoundingClientRect().height);
        // console.log(node.getBBox().height);

        TweenLite.set("#CLOUDS2", {
          left: d3.event.transform.x * ratio,
          y: d3.event.transform.y * ratio,
          scale: d3.event.transform.k
        });
      }
    }
    // this.maproot.attr("transform", "translate(0,86)");

    this.svg.call(this.zoom);
  };

  addEventListeners = () => {
    const InteractiveMap = this.InteractiveMap;
    const setLastActive = this.setLastActive;
    const zoomed = this.zoomed;
    const vehicles = this.maproot.selectAll("#ENGINES > g");

    function handleMouseDown(d, i) {
      const id = d3.select(this).attr("id");
      if (Engines_zmap[id]) {
        setLastActive(d3.select(this));
        d3.select(this).attr("class", "active");
        InteractiveMap.infoOpen(id);
        if (InteractiveMap.fullScreen) zoomed(this);
      }
    }

    vehicles
      .on("mousedown", handleMouseDown)
      .on("mouseover", function(d, i) {
        const g = d3.select(this);
        const id = g.attr("id");
        if (Engines_zmap[id]) g.attr("class", "hover");
      })
      .on("mouseout", function(d, i) {
        const g = d3.select(this);
        const active = d3.select(this).attr("class") === "active";
        if (!active) {
          g.attr("class", "");
        }
      })
      .append("title")
      .text(function(d) {
        return d3.select(this.parentNode).attr("id");
      });
  };

  zoomed = (d = null) => {
    /* vertically centred.								*/
    const mw = window.innerWidth;
    const mh = window.innerHeight;
    const node = this.maproot.node();

    /* get top left co-ordinates and width and height 	*/
    if (this.isZoom) {
      this.isZoom = false;
      this.maproot
        .transition()
        .duration(1250)
        .attr("transform", this.transformVal);

      TweenLite.to("#CLOUDS2", 0.75, {
        opacity: 1,

        ease: Sine.easeIn,
        delay: 0.5,
        onComplete: this.animation.moveClouds
      });
    } else {
      const xy = this.getBoundingBox(d);
      this.isZoom = true;
      /* scale is the max number of times bounding box will fit into container, capped at 3 times */
      const scale = Math.min(mw / xy[1], mh / xy[3], 3);
      /* tx and ty are the translations of the x and y co-ordinates */
      /* the translation centers the bounding box in the container  */
      const tx = -xy[0] + (mw - xy[1] * scale) / (2 * scale);
      const ty = -xy[2] + (mh - xy[3] * scale) / (2 * scale) + appBarHeight;

      this.maproot
        .transition()
        .duration(1250)
        .attr(
          "transform",
          "scale(" + scale + ")translate(" + tx + "," + ty + ")"
        );

      TweenLite.to("#CLOUDS2", 0.25, {
        opacity: 0,
        ease: Sine.easeIn
      });
    }
  };

  resetZoom() {
    if (this.zoom) this.svg.call(this.zoom.transform, d3.zoomIdentity);
    this.svg.on(".zoom", null);
  }

  getBoundingBox(selection) {
    /* get x,y co-ordinates of top-left of bounding box and width and height */
    var bbox = selection.getBBox();
    var cx = bbox.x + bbox.width / 2;
    var cy = bbox.y + bbox.height / 2;
    return [bbox.x, bbox.width, bbox.y, bbox.height, cx, cy];
  }

  setLastActive = val => {
    this.lastActive = val;
  };

  getLastActive = val => {
    return this.lastActive;
  };

  getRoot() {
    return this.maproot;
  }

  stopAnimation() {
    this.animation.skip();
  }

  setTimeline() {
    const full_timeline = this.maproot.select("#Full_x5F_Timeline_1_");
    const tablet_timeline = this.maproot.select("#Tablet_x5F_Timeline");
    // const full_timeline = this.maproot.select('#Full_Timeline');
    // const tablet_timeline = this.maproot.select('#Tablet_Timeline');
    if (!this.InteractiveMap.fullScreen) {
      full_timeline.style("display", "none");
      tablet_timeline.style("display", "block");
    } else {
      this.addZoom();
      full_timeline.style("display", "block");
      tablet_timeline.style("display", "none");
    }
  }
}
